export enum AlertTypeEnum {
    success = 'success',
    error = 'error',
    warning	= 'warning',
    info = 'info',
    question = 'question'
}
